import React, { useState } from "react";
import { Outlet, Link } from "react-router-dom";
import logo from "../images/logo.svg";

const LandingLayout = () => {
  const [open, setOpen] = useState(false);

  const onLinkClick = (e, hash) => {
    e.preventDefault();
    setOpen(false);
    const el = document.getElementById(hash);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div className="landing">
      <header className="landing__header">
        <div className="landing__header-inner">
          <Link
            to="/"
            className="landing__logo"
            aria-label="ShareMy"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          >
            <img src={logo} alt="ShareMy" />
          </Link>
          <nav className={`landing__nav ${open ? "is-open" : ""}`}>
            <a href="#how" onClick={(e) => onLinkClick(e, "how")}>
              How It Works
            </a>
            <a href="#features" onClick={(e) => onLinkClick(e, "features")}>
              Features
            </a>
            <a href="#activities" onClick={(e) => onLinkClick(e, "activities")}>
              Activities
            </a>
            <a href="#faq" onClick={(e) => onLinkClick(e, "faq")}>
              FAQ
            </a>
          </nav>
          <a
            className="landing__cta"
            href="https://apps.apple.com/app/id6737514100"
            target="_blank"
            rel="noopener noreferrer"
          >
            Download the App
          </a>
          <button
            type="button"
            className={`landing__burger ${open ? "is-open" : ""}`}
            onClick={() => setOpen((v) => !v)}
            aria-label="Menu"
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </header>
      <main className="landing__main">
        <Outlet />
      </main>
    </div>
  );
};

export default LandingLayout;
